import React from "react";
import styled from "styled-components";

const breakpoints = {
  tablet: 768,
  phone: 480,
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

const HeroCard = styled.div`
  background-color: transparent;
  border-radius: 5px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
`;

const HeroImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: 5px;
`;

const TableWrapper = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.08);
`;

const Header = styled.div`
  font-size: 16px;
  font-weight: bold;
  padding: 12px 16px;
  background-color: ${({ colors }) => colors?.buttonBackground || "#2C4960"};
  color: ${({ colors }) => colors?.buttonText || "#ffffff"};
  border-radius: 5px 5px 0 0;
`;

const TableContainer = styled.div`
  background-color: #ffffff;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  font-size: 11px;

  @media (max-width: ${breakpoints.phone}px) {
    table-layout: fixed;
    word-wrap: break-word;
  }
`;

const HeadCell = styled.th`
  background-color: #ffffff;
  color: ${({ colors }) => colors?.buttonBackground || "#2C4960"};
  font-size: 11px;
  padding: 10px;
  text-align: center;
`;

const Row = styled.tr`
  background-color: ${({ iseven }) => (iseven ? "#dcdcdc" : "#ffffff")};
`;

const DescriptionCell = styled.td`
  padding: 12px 16px;
  text-align: left;
  font-size: 13px;
  color: #111111;
`;

const DownloadCell = styled.td`
  padding: 12px 16px;
  text-align: center;

  a {
    color: ${({ colors }) => colors?.buttonBackground || "#2C4960"};
    font-weight: 400;
    text-decoration: none;
  }
`;

const CCSSDownload = ({ colors, heroImage, resources }) => (
  <Container>
    <HeroCard>
      <HeroImage src={heroImage} alt="Common Core State Standards" />
    </HeroCard>

    <TableWrapper>
      <Header colors={colors}>Common Core State Standards</Header>
      <TableContainer>
        <Table>
          <thead>
            <tr>
              <HeadCell colors={colors}>Description</HeadCell>
              <HeadCell colors={colors}>Download</HeadCell>
            </tr>
          </thead>
          <tbody>
            {resources?.map(({ description, href }, index) => (
              <Row key={description} iseven={index % 2 === 0}>
                <DescriptionCell>{description}</DescriptionCell>
                <DownloadCell colors={colors}>
                  <a href={href} target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                </DownloadCell>
              </Row>
            ))}
          </tbody>
        </Table>
      </TableContainer>
    </TableWrapper>
  </Container>
);

export default CCSSDownload;
